export const module = {
  info: {
    name: 'voip-rate-division',
    caption: 'voip rate division'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
